declare var requestIdleCallback: ((cb: () => void) => void) | undefined;

const rIC: ((cb: () => void) => void) =
  typeof requestIdleCallback === 'undefined'
    ? (cb: () => void) => setTimeout(cb, 0)
    : requestIdleCallback;

export default rIC;



// WEBPACK FOOTER //
// ./src/requestIdleCallback.ts